<div
  [class]="!isModal ? 'router-outlet' : 'main-router-outlet'"
  [ngClass]="alayticsService.currentTheme === 'material-dark' ? 'dark-theme' : ''"
>
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    size="small"
    *ngIf="router.url.includes('admin-dashboard') && isExpand"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="false"
    [zIndex]="1003"
  >
  </ngx-spinner>
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    size="small"
    *ngIf="title && (title === 'administration' || title === 'teacherNewAcademicYearSetup')"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="false"
    [zIndex]="1003"
  >
  </ngx-spinner>
  <div>
    <div class="row w-100" *ngIf="title && title === 'administration'">
      <div class="col-md-4">
        <img
          src="/assets/images/RespondEDU-Logo-Colored.svg"
          alt="logo-img"
          height="100"
          width="200"
          style="border-radius: 50%"
          *ngIf="!isTeacherOnlyUser"
        />
        <img src="/assets/images/Teacher-only-color-logo.svg" alt="logo-img" height="100" width="150" *ngIf="isTeacherOnlyUser" />
      </div>
      <div class="col-md-4 d-flex justify-content-center">
        <div class="w-100">
          <ngx-form-stepper></ngx-form-stepper>
        </div>
      </div>
      <div class="col-md-4"></div>
    </div>
    <div class="text-right mb-2 header-content" *ngIf="isAdminDashboard && isExpand">
      <div class="quicksand-bold-label weekly-period-text" *ngIf="storageService.detectMob()">Weekly Periods</div>
      <button class="btn-close" (click)="closeDialog()">
        <nb-icon icon="collapse" class="icon-close-expand-view techear-periods-header"></nb-icon>
      </button>
    </div>
    <!-- <div *ngIf="isAdminDashboard === true" class="d-flex select-teacher">
      <mat-form-field appearance="outline" class="">
        <mat-label>Select Teacher</mat-label>
        <mat-select
          name="type"
          [(ngModel)]="currentTeacher"
          (selectionChange)="getPeriodsByTeacherId()"
          [formControl]="teacherCtrl"
        >
          <mat-option>
            <ngx-mat-select-search
              [formControl]="teacherFilterCtrl"
              placeholderLabel="Find teacher..."
              noEntriesFoundLabel="'no matching teacher found'"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option
            class="quicksand-bold-label select-range"
            *ngFor="let teacher of filteredTeacher | async"
            [value]="teacher"
          >
            {{ teacher?.firstName | titlecase }}
            {{ teacher?.lastName | titlecase }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
    <div [ngClass]="title && title === 'administration' ? 'container' : ''">
      <div *ngIf="classroom && isModal">
        <div class="row" style="margin-top: -1rem">
          <div class="col-md-12 d-flex justify-content-center">
            <div>
              <nb-card class="classroom-details">
                <nb-card-body>
                  <div class="d-flex justify-content-between">
                    <div class="classroom-name-content text-left">
                      <h5 class="classroom-name quicksand-bold-label">
                        {{ classroom?.name }}
                      </h5>

                      <div class="classroom-subject quicksand-bold-label">
                        {{ classroom?.subject | uppercase }}
                      </div>
                    </div>

                    <div class="d-flex" style="margin-right: -5px">
                      <div class="classroom-code text-center quicksand-normal-label">
                        {{ classroom?.code }}
                      </div>
                    </div>
                  </div>
                </nb-card-body>
              </nb-card>
            </div>

            <div class="btn-close-content">
              <button class="btn-close" (click)="closeExpandView()">
                <nb-icon icon="expand" class="icon-close-expand-view"></nb-icon>
              </button>
            </div>
          </div>
        </div>
        <br />
      </div>
      <div class="trial-period-message mb-4" *ngIf="isMock && title && title === 'administration'">
        <label class="quicksand-bold-label trial-period-label"> Trial Period Users: </label>
        <label class="quicksand-normal-label trial-message"
          >This is where you would setup your bell schedule. If your admin has created one or more versions, you would have access to those
          or you can simply choose to create your own. Then you would assign your classes to the appropriate periods or blocks... For your
          trial demo, simply click “Go To Dashboard” to start your trial and play with all the exciting features!</label
        >
      </div>

      <div style="position: absolute; right: 3rem; top: 17%; z-index: 9999">
        <button
          nbButton
          color="warn"
          class="go-to-dashboard quicksand-bold-label m-2 cursor-pointer"
          (click)="submit()"
          *ngIf="title === 'administration' && isMock"
        >
          Go To Dashboard
        </button>
      </div>
      <div class="container-fluid" [ngClass]="title && title === 'administration' ? 'administration-calendar' : ''">
        <div
          class="row   {{ isAdminDashboard ? '' : 'mt-3' }} {{ isTeacherOnlyUser ? 'justify-content-end' : '' }}
          {{ isTeacherOnlyUser ? 'main-content' : '' }}"
          [ngClass]="isModal ? (classroom ? 'p-3 bg-white' : '') : ''"
        >
          <div
            class="d-flex"
            [ngClass]="
              title
                ? title === 'administration'
                  ? 'w-100 justify-content-between header-content'
                  : 'w-100 justify-content-end'
                : isModal
                ? 'w-100 justify-content-center'
                : ''
            "
          >
            <div *ngIf="title && title === 'administration' && !isTeacherOnlyUser">
              <h5 class="info-label quicksand-bold-label mb-0">Instructional Period Scheduling</h5>
            </div>

            <div *ngIf="title && title === 'administration' && isTeacherOnlyUser">
              <h5 class="info-label quicksand-bold-label mb-0">Calendar Setup</h5>
            </div>

            <div *ngIf="title && title !== 'administration' && title !== 'teacherNewAcademicYearSetup'" class="d-flex mb-3">
              <!-- <form
                [formGroup]="selectGradeForm"
                *ngIf="!classroom"
                class="mb-3"
              >
                <label
                  class="quicksand-normal-label mr-2"
                  style="font-size: 13px"
                  >Filter By Grade:</label
                >
                <nb-select
                  placeholder="Select Grade"
                  class="select-bar"
                  (selectedChange)="getAllInstructionalDays($event)"
                  formControlName="grade"
                >
                  <nb-option value="all" selected>All</nb-option>
                  <nb-option *ngFor="let grade of grades" [value]="grade.id">{{ grade.grade }}</nb-option>
                </nb-select>
              </form> -->

              <label class="quicksand-normal-label mr-2" style="font-size: 15px; margin-top: 15px">Bell Schedule:</label>
              <mat-select
                placeholder="Please Select Bell Schedule"
                (selectionChange)="getBellScheduleAndPeriods($event.value)"
                [(ngModel)]="currentBellShedule"
                class="bell-shedule-version"
                style="width: 200px"
              >
                <mat-option
                  *ngFor="let bellShedule of bellShedules; let i = index"
                  [value]="bellShedule"
                  class="quicksand-bold-label select-range select-school-name"
                  ><span *ngIf="bellShedule?.name" class="quicksand-bold-label">
                    {{ bellShedule?.name | titlecase }}
                  </span>
                  <span *ngIf="!bellShedule?.name" class="quicksand-bold-label">Version {{ i + 1 }}</span></mat-option
                >
              </mat-select>
            </div>
          </div>

          <div
            [ngClass]="{
              'mt-3': title,
              'card-padding': title === 'administration'
            }"
          >
            <label
              class="quicksand-bold-label mb-3 add-new-period"
              *ngIf="title && (title === 'administration' || title === 'teacherNewAcademicYearSetup') && !isTeacherOnlyUser"
            >
              Please designate the subject and grade you teach in each instructional period of the school week by clicking on the period
              below. Once completed, you will be taken to your portal, where you may create your classrooms (you can also update/delete
              added periods by clicking on that period below).
            </label>

            <label class="quicksand-bold-label mb-3 add-new-period" *ngIf="title && title === 'administration' && isTeacherOnlyUser">
              Designate the first and last days of school as well as your preferred calendar start and end times. This will set up your
              pacing plan calendars as well as your daily lesson plan organization.
            </label>
            <label class="quicksand-normal-label add-new-period" *ngIf="title && title === 'teacherNewAcademicYearSetup'">
              You can only use one calendar where you have added the periods. Please ensure your selected bell schedule remains the same
              when saving the data.
            </label>
          </div>

          <div
            class="form-group w-100"
            *ngIf="title && (title === 'administration' || title === 'teacherNewAcademicYearSetup') && !isTeacherOnlyUser"
            [ngClass]="{
              'card-padding': title === 'administration'
            }"
          >
            <h6 class="quicksand-bold-label">
              <span *ngIf="title && title === 'administration'">Select</span>
              Bell Schedule
            </h6>

            <mat-select
              placeholder="Please Select Bell Schedule"
              (selectionChange)="getBellScheduleAndPeriods($event.value)"
              [(ngModel)]="currentBellShedule"
              class="bell-shedule-version"
              [disabled]="title && title !== 'administration' && title !== 'teacherNewAcademicYearSetup'"
            >
              <mat-option
                *ngFor="let bellShedule of bellShedules; let i = index"
                [value]="bellShedule"
                class="quicksand-bold-label select-range select-school-name"
                ><span *ngIf="bellShedule?.name">
                  {{ bellShedule?.name | titlecase }}
                </span>
                <span *ngIf="!bellShedule?.name">Version {{ i + 1 }}</span></mat-option
              >
            </mat-select>

            <div *ngIf="title && (title === 'administration' || title === 'teacherNewAcademicYearSetup')" class="pt-3">
              <button
                nbButton
                class="save quicksand-bold-label float-right"
                (click)="isTeacherOnlyUser ? openConfirmationDialog() : submit()"
                [disabled]="isMock"
              >
                Save and Next
              </button>
            </div>
          </div>
          <!-- teacher only warning text -->
          <div
            *ngIf="
              teacherOnlyClassroomData?.extras?.setUpWeeklyPeriods === false &&
              instructionalPeroids &&
              instructionalPeroids.length > 0 &&
              !isTeacherOnlyUser
            "
            class="d-flex row day-selection-warning quicksand-normal-label w-100 ml-1"
          >
            <div class="col-1 py-3 pl-3 pr-0">
              <nb-icon icon="info"> </nb-icon>
            </div>
            <div
              class="quicksand-semi-bold-label col-11 py-3 pl-0 pr-3 info-text"
              *ngIf="
                teacherOnlyClassroomData?.extras?.setUpWeeklyPeriods === false &&
                instructionalPeroids &&
                instructionalPeroids.length > 0 &&
                !isTeacherOnlyUser
              "
            >
              You have added the weekly period as
              <ul class="custom-bullets">
                <li *ngFor="let event of teacherOnlyClassroomData.extras.eventDates" class="list-group quicksand-semi-bold-label px-0">
                  <span class="ml-3 list-text"> {{ event.day | titlecase }}</span>
                </li>
              </ul>
              <div class="quicksand-bold-label info-text">
                If you want to retain the data, you must select a time for the days listed above.
              </div>
            </div>
          </div>
          <div
            class="table-container w-100"
            [ngClass]="{
              'card-padding': title === 'administration'
            }"
          >
            <table
              class="table table-bordered mt-2 teacher-period-table table-border-radius"
              *ngIf="instructionalPeroids && instructionalPeroids.length > 0 && !isTeacherOnlyUser"
            >
              <thead *ngIf="instructionalPeroids && instructionalPeroids.length > 0">
                <tr class="table-header-row">
                  <th
                    scope="col"
                    class="main-header teacher-period-text"
                    [ngClass]="!isModal ? 'sm-content' : 'lg-content'"
                    *ngFor="let weekday of weekDays"
                  >
                    {{ weekday | uppercase }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <td
                  *ngFor="let weekday of weekDays"
                  class="pt-0 pb-0 period-content"
                  [ngClass]="
                    title && (title === 'administration' || title === 'teacherNewAcademicYearSetup' || title === 'profile')
                      ? 'cursor-pointer'
                      : ''
                  "
                >
                  <ng-container *ngFor="let peroid of instructionalPeroids">
                    <ng-container *ngIf="peroid.day === weekday">
                      <div
                        class="row period-content"
                        *ngFor="let item of peroid?.periods; let i = index"
                        (click)="
                          title && (title === 'administration' || title === 'teacherNewAcademicYearSetup' || title === 'profile')
                            ? addPeroid(item, peroid.day)
                            : null
                        "
                        [ngClass]="{
                          'day-periods': i !== peroid?.periods.length - 1,
                        }"
                      >
                        <div
                          class="col-md-12 m-auto"
                          [ngClass]="{
                            'selected-period': checkIfSelectedPeriod(peroid.day, item),
                            'unselected-period': !checkIfSelectedPeriod(peroid.day, item),
                          }"
                        >
                          <div
                            *ngIf="
                              isEditClassRoom &&
                              (item?.title?.toLowerCase().includes('period') || item?.title?.toLowerCase().includes('block'))
                            "
                            class="d-flex align-items-center"
                            (click)="$event.stopPropagation()"
                          >
                            <mat-checkbox
                              class="auto-pilot custom-checkbox p-2 float-left"
                              (change)="toggleCheckBox($event, item, peroid.day)"
                              color="primary"
                              [checked]="checkIfSelectedPeriod(peroid.day, item)"
                            >
                            </mat-checkbox>

                            <label
                              class="quicksand-normal-label period-time cursor-pointer title-color period-text title-txt mb-1"
                              [ngClass]="isModal ? 'period-time-sm' : 'peroid-time-pm'"
                              >{{ item.title }}</label
                            >
                          </div>
                          <div
                            [ngClass]="
                              !item?.title?.toLowerCase().includes('period') && !item?.title?.toLowerCase().includes('block')
                                ? 'period-break'
                                : ''
                            "
                          >
                            <label
                              class="quicksand-normal-label period-time cursor-pointer title-color period-text title-txt"
                              [ngClass]="isModal ? 'period-time-sm' : 'peroid-time-pm'"
                              *ngIf="
                                (title && (title === 'administration' || title === 'profile' || title === 'teacherNewAcademicYearSetup')) ||
                                isAdminDashboard
                              "
                              >{{ item.title }}</label
                            >
                            <!--*ngIf="title && (title === 'administration' || title === 'profile')"-->
                            <div class="period-time-content">
                              <label
                                class="quicksand-bold-label period-time ml-1 dark-label-content cursor-pointer time1"
                                [ngClass]="isModal ? 'period-time-sm' : 'peroid-time-pm'"
                              >
                                Time:
                                {{ item.start | date: 'h:mm a' }} - {{ item.end | date: 'h:mm a' }}</label
                              >
                              <div *ngIf="item.subject && item.grade">
                                <div class="period-time-content">
                                  <label
                                    class="period-time quicksand-normal-label cursor-pointer"
                                    [ngClass]="isModal ? 'period-time-sm' : 'peroid-time-pm'"
                                    >Subject:
                                  </label>
                                  <label
                                    class="period-time quicksand-bold-label dark-label-content ml-1 cursor-pointer"
                                    [ngClass]="isModal ? 'period-time-sm' : 'peroid-time-pm'"
                                    >{{ item.subject }}</label
                                  >
                                </div>

                                <div class="period-time-content">
                                  <label
                                    class="period-time quicksand-normal-label cursor-pointer"
                                    [ngClass]="isModal ? 'period-time-sm' : 'peroid-time-pm'"
                                    >Grade:
                                  </label>
                                  <label
                                    class="period-time quicksand-bold-label dark-label-content ml-1 cursor-pointer"
                                    [ngClass]="isModal ? 'period-time-sm' : 'peroid-time-pm'"
                                  >
                                    {{ item.grade }}</label
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </td>
              </tbody>
            </table>

            <!-- teacher-only-part -->
            <form [formGroup]="schoolForm" *ngIf="isTeacherOnlyUser">
              <div class="row mb-3 school-time p-3">
                <!-- <ng-container> -->
                <div class="col-md-6 pb-1">
                  <div class="school-form-group quicksand-bold-label">
                    <label>First Day of School <span class="required-field">*</span></label>

                    <input placeholder="Enter School Start Date" formControlName="startDate" [nbDatepicker]="dateTimePickerStartDate" />

                    <nb-datepicker #dateTimePickerStartDate></nb-datepicker>
                    <label
                      class="quicksand-bold-label error-label"
                      *ngIf="
                        schoolForm.controls.startDate.invalid &&
                        (schoolForm.controls.startDate.dirty || schoolForm.controls.startDate.touched)
                      "
                      >Enter School Start Date
                    </label>
                  </div>
                </div>

                <div class="col-md-6 pb-1">
                  <div class="school-form-group quicksand-bold-label">
                    <label>Last Day of School <span class="required-field">*</span></label>

                    <input type="text" readonly placeholder="Enter School End Date" *ngIf="!schoolForm.value.startDate" />

                    <input
                      class="bg-white quicksand-normal-label"
                      *ngIf="schoolForm.value.startDate"
                      placeholder="Enter End Date"
                      formControlName="endDate"
                      [nbDatepicker]="dateTimePickerEndDate"
                      [min]="schoolForm.value.startDate"
                    />
                    <nb-datepicker #dateTimePickerEndDate [min]="schoolForm.value.startDate"></nb-datepicker>
                    <label
                      class="quicksand-bold-label error-label"
                      *ngIf="
                        schoolForm.controls.endDate.invalid && (schoolForm.controls.endDate.dirty || schoolForm.controls.endDate.touched)
                      "
                    >
                      End Date must be later than Start Date
                    </label>
                  </div>
                </div>
                <!-- </ng-container> -->
              </div>
              <div class="row quicksand-bold-label mb-3 school-day p-3">
                <div class="col-md-6 pb-1">
                  <div class="school-form-group">
                    <label
                      >School Day Start Time
                      <span class="required-field">*</span>
                    </label>

                    <input
                      type="text"
                      [nbTimepicker]="timepickerStartTime"
                      formControlName="startTime"
                      placeholder="Enter School Start Time"
                    />
                    <nb-timepicker #timepickerStartTime="nbTimepicker" twelveHoursFormat></nb-timepicker>
                    <label
                      class="quicksand-bold-label error-label"
                      *ngIf="
                        schoolForm.controls.startTime.invalid &&
                        (schoolForm.controls.startTime.dirty || schoolForm.controls.startTime.touched)
                      "
                      >Enter School Start Time
                    </label>
                  </div>
                </div>

                <div class="col-md-6 pb-1">
                  <div class="school-form-group">
                    <label
                      >School Day End Time
                      <span class="required-field">*</span>
                    </label>
                    <input type="text" readonly *ngIf="!schoolForm.value.startTime" placeholder="Enter School End Time" />
                    <input
                      type="text"
                      [nbTimepicker]="timepickerEndTime"
                      *ngIf="schoolForm.value.startTime"
                      formControlName="endTime"
                      placeholder="Enter School End Time"
                      [min]="schoolForm.value.startTime"
                    />
                    <nb-timepicker #timepickerEndTime="nbTimepicker" twelveHoursFormat></nb-timepicker>
                    <label
                      class="quicksand-bold-label error-label"
                      *ngIf="
                        schoolForm.controls.endTime.invalid && (schoolForm.controls.endTime.dirty || schoolForm.controls.endTime.touched)
                      "
                      >End time must be later than start time
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div *ngIf="title && title === 'administration' && isTeacherOnlyUser" class="pr-3 pb-3 my-3">
            <button nbButton class="save quicksand-bold-label float-right" (click)="addSchoolCalendar()" [disabled]="schoolForm.invalid">
              Save & Next
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="instructionalPeroids && instructionalPeroids.length === 0 && !isTeacherOnlyUser"
      class="quicksand-bold-label text-center instructional-periods"
      [ngStyle]="{
        height: isEditClassRoom && instructionalPeroids?.length === 0 ? '650px' : ''
      }"
    >
      <img src="/assets/images/respond-edu.svg" alt="responed-edu" height="100" width="100" />
      <br />
      No Instructional Periods Found!
    </div>

    <div class="d-flex" *ngIf="router.url.includes('test-quizzes') && instructionalPeroids.length > 0">
      <button nbButton class="ok ml-auto quicksand-bold-label text-capitalize" (click)="saveWeeklyPeriods.emit(true)">Ok</button>
    </div>
  </div>

  <ng-template #addTeacherPeroids let-data>
    <span class="icon-close-classroom-modal d-block cursor-pointer ml-auto" (click)="dialog.closeAll()">
      <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
    </span>
    <div [ngClass]="!isAddPeriod ? 'd-flex justify-content-between mt-3' : ''">
      <h6 class="text-center mb-0 quicksand-bold-label">Please select subject and grade!</h6>
      <div *ngIf="!isAddPeriod" (click)="deleteTeacherPeriod(true, deleteDialog)" class="btn-delete cursor-pointer">
        <img src="/assets/icons/delete.svg" alt="share-icon" class="cursor-pointer" height="20" width="20" />
      </div>
    </div>

    <form [formGroup]="addTeacherPeroidForm" class="mt-3">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <mat-form-field appearance="outline" class="subject-field w-100">
              <mat-label>Select Subject</mat-label>
              <mat-select aria-label="Select Subject" formControlName="subject">
                <mat-option
                  *ngFor="let subject of subjects"
                  [value]="subject.id"
                  class="quicksand-bold-label select-range select-school-name"
                >
                  {{ subject?.subject }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <mat-form-field appearance="outline" class="subject-field w-100">
              <mat-label>Select Grade</mat-label>
              <mat-select aria-label="Select Grade" formControlName="grade">
                <mat-option *ngFor="let grade of grades" [value]="grade.id" class="quicksand-bold-label select-range select-school-name">
                  {{ grade.grade }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="col-md-12 check-all-periods">
          <nb-checkbox *ngIf="isAddPeriod" formControlName="isAddAll" class="quicksand-bold-label cursor-pointer"
            ><span class="quicksand-bold-label cursor-pointer">Add Period For Whole Week</span></nb-checkbox
          >
        </div>
      </div>

      <div [ngClass]="!isAddPeriod ? 'd-flex mt-0' : 'mt-3'">
        <!-- Pass startTime and endTime to match only the specific time slot across all days -->
        <button
          mat-raised-button
          color="primary"
          class="footer-btn w-100 quicksand-bold-label"
          [disabled]="addTeacherPeroidForm.invalid"
          (click)="
            addTeacherPeroidForm.value.isAddAll
              ? addPeriodToAllDays(data.peroid, data.startTime, data.endTime)
              : addTeacherPeroid(data.day, data.peroid, data.startTime, data.endTime)
          "
        >
          <span *ngIf="isAddPeriod">Add Period</span>
          <span *ngIf="!isAddPeriod">Update Period</span>
        </button>
      </div>
    </form>
  </ng-template>

  <ng-template #deleteDialog let-data let-ref="dialogRef">
    <nb-card>
      <nb-card-body>
        <div class="text-center">
          <img src="/assets/icons/featured icon.svg" alt="delete-icon" loading="lazy" />
          <br />

          <label class="label-delete-lesson-plan mt-2 quicksand-bold-label">Delete Instructional Period</label>
          <br />
          <label class="delete-lesson-plan-confirmation quicksand-bold-label"
            >Are you sure want to delete this instructional period ?</label
          >
        </div>
        <div class="d-flex">
          <button nbButton class="delete-lesson-plan bg-white m-2 w-100 quicksand-bold-label text-capitalize" (click)="ref.close()">
            Cancel
          </button>
          <button
            nbButton
            color="warn"
            class="delete-lesson-plan delete m-2 w-100 quicksand-bold-label text-capitalize"
            (click)="deleteTeacherPeriod()"
          >
            Delete
          </button>
        </div>
      </nb-card-body>
    </nb-card>
  </ng-template>
</div>
